<template>
    <section>
        <el-dialog
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :visible.sync="dialogVisible"
            width="410px"
        >
            <div class="m-login-part">
                <h2>第六届券商APP风云榜</h2>
                <p>欢迎您！</p>
            </div>
            <div class="m-login-input">
                <el-input
                    class="u-login-input"
                    v-model="verification"
                    autocomplete="off"
                    placeholder="请输入报名验证码"
                ></el-input>
                <el-button type="primary" @click="getLogin">确 定</el-button>
            </div>
            <div slot="footer" class="dialog-footer">
                <p class="u-login-des2">说明：验证码为报名标识，若有登陆问题请及时联系主办方，联系电话：18010077174 / 17610891929</p>
            </div>
        </el-dialog>
        <!-- <transition>
            <div class="m-mask" v-show="isShow"></div>
        </transition>-->
    </section>
</template>

<script>
export default {
    name:"LoginVerify",
    data() {
        return {
            dialogVisible: sessionStorage.getItem("name") ? false : true,
            // dialogVisible: this.$store.state.isLogin,
            verification: ""
            // isShow: sessionStorage.getItem("isShow")
        };
    },
    methods: {
        getLogin() {
            var _this = this;
            let url =
                "//support.finance.sina.com.cn/service/api/openapi.php/AppBrokerVoteService.auth";
                // http://support.finance.sina.com.cn/service/api/openapi.php/AppBrokerVoteService.auth?acode=zzzz_u&atype=qs
            // ?acode=ajzq_020235f9c2af&atype=qs"
            let param = new URLSearchParams();
            param.append("acode", _this.verification);
            param.append("atype", "qs");
            // console.log(param);
            this.axios({
                method: "POST",
                url: url,
                data: param
            })
                .then(function(response) {
                    console.log(response);
                    let data = response.data.result;
                    if (data.status.code == 0) {
                        console.log(data.data.name);
                        sessionStorage.setItem("name", data.data.name);
                        sessionStorage.setItem("acode", _this.verification);
                        _this.$message({
                            message: "恭喜你，验证成功！",
                            type: "success"
                        });
                        _this.dialogVisible = false;
                        _this.$router.push({ path: "home" });
                        // const redirect = this.$route.query.redirect;
                        // if (redirect) {
                        //     //如果redirect存在说明当前用户是进入某页面后未登陆自动跳转到登陆页面来的，所以登陆完成后得再次回跳到该地址
                        //     this.$router.push(redirect);
                        // } else {
                        //     //否则跳转到默认的页面，首页或者其他页面
                        //     this.$router.push("/");
                        // }
                    } else {
                        _this.$message({
                            message: "请输入正确的验证码",
                            type: "warning"
                        });
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        }
    }
};
</script>
<style lang="scss">
.el-dialog {
    border: 1px solid #ead9b8;
    background: #ead9b8;
    .el-dialog__header {
        display: none;
        padding: 0;
        .el-dialog__headerbtn {
            top: 10px;
            right: 10px;
        }
        .el-dialog__close {
            font-size: 26px;
            color: #fff4dd;
        }
    }
    .el-dialog__body {
        padding: 0;
    }
}
.m-login-part {
    padding-top: 50px;
    background: #6a543a;
    background-image: linear-gradient(0deg, #523f1d 0%, #6a543a 99%);
    h2 {
        padding-bottom: 16px;
        line-height: 28px;
        font-size: 28px;
        color: #ffffff;
        text-align: center;
    }
    p {
        padding-bottom: 26px;
        font-size: 24px;
        color: #fff4dd;
        text-align: center;
    }
}
.u-login-des2 {
    // padding: 10px 20px;
    font-size: 16px;
    color: #7f6634;
    line-height: 28px;
    text-align: left;
}
.m-login-input {
    padding: 50px 20px 35px;
    &:after {
        content: "";
        display: block;
        height: 0;
        width: 0;
        overflow: hidden;
        clear: both;
    }
    .u-login-input {
        float: left;
        width: 204px;
    }
    .el-button {
        float: right;
        width: 150px;
        background: #7f6634;
        // height: 50px;
        // line-height: 50pkx;
    }
}
// .el-dialog__wrapper{
//     z-index: 2002;
// }
.m-mask {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    background: #000;
    z-index: 2000;
}
</style>